import { Property } from 'csstype'
import React from 'react'

import Text from 'components/common/Text'
import theme from 'theme'

const EmptyCard: React.FC<{
  title: string
  titleColor?: Property.Color
}> = ({ titleColor = theme.colors.steel[1], title, children }) => (
  <div
    data-test-empty-card
    css={{
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column'
    }}
  >
    <Text
      as="h3"
      css={{
        marginBottom: theme.space[2],
        color: titleColor
      }}
    >
      {title}
    </Text>
    {children}
  </div>
)
export default EmptyCard
